import { Component, OnInit, OnDestroy } from "@angular/core";
import * as $ from "jquery";
import { CentralService } from "../servicios/central.service";
import {
  faSignInAlt,
  faKey,
  faEuroSign,
  faTractor,
  faMoneyBill,
  faFileInvoice,
  faUndo,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { AvisosComponent } from "../avisos/avisos.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { Router } from "@angular/router";
import * as XLSX from "xlsx";

@Component({
  selector: "app-entregalis",
  templateUrl: "./entregalis.component.html",
  styleUrls: ["./entregalis.component.css"],
})
export class EntregalisComponent implements OnInit, OnDestroy {
  dtOptions: any;
  dtTrigger: Subject<any> = new Subject();
  datosTabla: any[] = [];

  icoEntr = faSignInAlt;
  icoKey = faKey;
  icoEur = faEuroSign;
  icoTra = faTractor;
  icoMny = faMoneyBill;
  icoInv = faFileInvoice;
  icoRet = faUndo;
  icoFac = faFileAlt;
  fecdia: string;
  nomusu: string;
  menu: any;
  usuarioActual: any;

  codigo: number;

  iconos = [
    this.icoKey,
    this.icoEur,
    this.icoTra,
    this.icoMny,
    this.icoInv,
    this.icoFac,
  ];

  resul: boolean;

  modoLis = 0;
  prifec: string;
  ultfec: string;

  primerafecha: string;
  ultimafecha: string;

  constructor(
    private srvCentral: CentralService,
    private modalService: NgbModal,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.fecdia = Date().toLocaleString();
    this.nomusu = this.srvCentral.datosIden.UsuNom;

    /* Cargo tabla de menús */
    if (this.srvCentral.datosIden.UsuUsu !== "") {
      const k = this.srvCentral.listaMnu.length;
      this.menu = [];
      for (let i = 0; i < k; i++) {
        this.menu.push({
          nombre: this.srvCentral.listaMnu[i].nombre,
          ruta: this.srvCentral.listaMnu[i].ruta,
          icono: this.iconos[this.srvCentral.listaMnu[i].ico],
        });
      }
    }

    this.modoLis = this.srvCentral.EntModoLis;
    this.prifec = this.srvCentral.fechaCadena(this.srvCentral.gnPriDia);
    this.ultfec = this.srvCentral.fechaCadena(this.srvCentral.gnUltDia);

    this.usuarioActual = localStorage.getItem("usuarioActual");
    this.codigo = JSON.parse(this.usuarioActual || "{}").codUsu;
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  persiana() {
    $("#wrapper").toggleClass("toggled");
  }

  cargarPedidos(): void {
    const fechaDesde = this.formatearFecha(this.primerafecha);
    const fechaHasta = this.formatearFecha(this.ultimafecha);

    this.srvCentral
      .listarCorderos(fechaDesde, fechaHasta, this.codigo)
      .subscribe((res) => {
        this.datosTabla = res;
        //console.log("Datos tabla:", this.datosTabla);
        this.dtTrigger.next(null);
      });
  }

  formatearFecha(fecha: string): string {
    if (!fecha) return "";
    const [year, month, day] = fecha.split("-");
    return `${day}-${month}-${year}`;
  }

  exportarAExcel(): void {
    if (!this.datosTabla || this.datosTabla.length === 0) {
      return;
    }

    const encabezados = [
      "Fecha",
      "Socio",
      "Nombre",
      "Explotación",
      "Hembras",
      "Machos",
      "Total",
      "Recogida",
    ];

    const filas = this.datosTabla.map((pedido: any) => [
      pedido.ttFecha,
      pedido.ttSocio,
      pedido.ttNombr,
      pedido.ttExplo,
      pedido.ttHembra,
      pedido.ttMachos,
      pedido.ttTotcor,
      pedido.ttRecoge === 0 ? "SI" : pedido.ttRecoge === 1 ? "NO" : "COOP",
    ]);

    const wsData = [encabezados, ...filas];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    ws["!cols"] = encabezados.map(() => ({ wch: 15 }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Entregas");

    const fecha = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(wb, `entregas_${fecha}.xlsx`);
  }
}
